export default __webpack_public_path__ + "static/media/recentIcon.5371caec.svg";